import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=4d8eea0f&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=4d8eea0f&prod&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=4d8eea0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8eea0f",
  null
  
)

export default component.exports